module.exports = "/fonts/vendor/mavon-editor/dist/fontello.svg?358e59d03a31036848aa171ee9679a87";